import { Injectable } from '@angular/core';
import {Globals} from '.././globals';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable()
export class BlogService {
  user:any;
  constructor(private http: HttpClient,private _global:Globals) {
  
  }
  readonly rootUrl = this._global.siteUrl;

  getBlogList(Obj){ 
    var reqHeader = new HttpHeaders({ 'No-Auth':'True'});
    return this.http.post(this.rootUrl + 'blog/getBlogList', Obj,{ headers: reqHeader});
  }
  saveBlogLike(Obj){
    return this.http.post(this.rootUrl + 'blog/saveBlogLike', Obj); 
  }
  saveBlog(Obj){
    return this.http.post(this.rootUrl + 'blog/saveBlog', Obj); 
  }
  updateBlog(Obj){
    return this.http.post(this.rootUrl + 'blog/updateBlog', Obj); 
  }
  
  deleteBlog(Obj){
    return this.http.post(this.rootUrl + 'blog/deleteBlog', Obj); 
  }
  deleteBlogLike(Obj){
    return this.http.post(this.rootUrl + 'blog/deleteBlogLike', Obj); 
  }
  approveBlog(Obj){

    return this.http.post(this.rootUrl + 'blog/approveBlog', Obj); 
  }
  getComments(Obj){
    var reqHeader = new HttpHeaders({ 'No-Auth':'True'});
    return this.http.post(this.rootUrl + 'blog/getComments', Obj,{ headers: reqHeader});

  }

  saveComment(Obj){
    var reqHeader = new HttpHeaders({ 'No-Auth':'True'});
    return this.http.post(this.rootUrl + 'blog/saveComment', Obj,{ headers: reqHeader});

  }

  saveCommentLike(Obj){
    return this.http.post(this.rootUrl + 'blog/saveCommentLike', Obj); 
  }

  deleteCommentLike(Obj){
    return this.http.post(this.rootUrl + 'blog/deleteCommentLike', Obj); 
  }

  bookmark(Obj){
    return this.http.post(this.rootUrl + 'blog/bookmark', Obj); 
  }

  voiceUpload(Obj){
   // return {};
   //console.log(Obj);
   return this.http.post(this.rootUrl + 'file/upload?folder=postAttachment&mediaFor=userPost', Obj); 
// return this.http.post(this.rootUrl + 'file/upload?folder=postAttachment&mediaFor=userPost', Obj); 
    
  }

  filterblog(Obj){
    var reqHeader = new HttpHeaders({ 'No-Auth':'True'});
    return this.http.post(this.rootUrl + 'blog/filterblog', Obj,{ headers: reqHeader});
   // return this.http.post(this.rootUrl + 'blog/filterblog', Obj); 
  }

  deleteComment(Obj){
    return this.http.post(this.rootUrl + 'blog/delcomment', Obj); 
  }
  editComment(Obj){
    return this.http.post(this.rootUrl + 'blog/editcomment', Obj); 
  }

  removeCommentAttachment(Obj){
    return this.http.post(this.rootUrl + 'blog/removeAttachment', Obj);  
  }

      
}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/service/blog.service.ts